<template>
    <div>
        <h2>{{ $store.getters['app/GET_APP_MODE'] == 'create' ? "เพิ่ม" : "แก้ไข"}}กลุ่มสิทธิ์</h2>
        <v-form v-model="isFormValid">         
          <v-card class="mt-4">
              <v-card-title>กลุ่มสิทธิ์</v-card-title>

              <div class="pa-8">
                <v-form @submit.prevent="submitForm" v-model="isFormValid">
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="formData.name"
                        outlined
                        label="ชื่อกลุ่ม *"                               
                        :rules="[validators.required, validators.maxLengthValidator(formData.name, 50)]"
                        hide-details="auto"          
                        dense  
                      ></v-text-field>
                    </v-col>
                  </v-row>                
                  <v-row>
                    <v-col>
                      <div class="text-body-1 font-weight-bold">สิทธิ์การอนุญาติ</div>
                      <div class="ability-table">
                        <template 
                        v-for="(ability, index) in abilities"
                        >
                          <div
                          v-if="ability.subject"
                          :key="index"
                          class="ability-row"
                          >
                            <div                           
                            class="ability-name">{{ converters.convertPageToText(ability.subject) }}</div>
                            <div 
                            v-for="(action, p_index) in ability.actions"
                            class="ability-permission">
                              <v-checkbox                              
                              :label="converters.convertPermissionToText(action)"                       
                              :key="ability.subject + '_' + action"
                              :value="action"
                              v-model="formData.ability[ability.subject]"
                              ></v-checkbox>
                            </div>
                          </div>                          
                          <div v-else                          
                          class="text-body-1 font-weight-bold"
                          :key="index"
                          >
                            <v-divider></v-divider>
                            <div class="mt-3">{{ ability.header }}</div>                            
                          </div>
                        </template>
                        <div></div>
                      </div>                     
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <delay-autocomplete
                        outlined
                        hide-selected               
                        deletable-chips
                        multiple
                        chips 
                        cache-items
                        v-model="formData.devices"             
                        label="เครื่อง POS"                        
                        no-data-text="ไม่พบข้อมูล"
                        :url="'/employee/role/deviceList'"
                        dense                        
                        return-object
                        ref="posDeviceAutocomplete"
                        item-text="name"
                        item-value="id"
                        clearable
                        hide-details="auto"                        
                      ></delay-autocomplete>
                    </v-col>
                  </v-row>
                </v-form>                       
              </div>

              <v-card-actions>              
                <v-btn
                  color="primary"               
                  large          
                  :disabled="!isFormValid"
                  :loading="sendingData"
                  @click="submitForm"
                  v-if="$store.getters['app/GET_APP_MODE'] != 'read'"
                >
                  {{ $store.getters['app/GET_APP_MODE'] == 'create' ? "สร้าง" : "แก้ไข"}}
                </v-btn>

                <v-btn
                  color="secondary"               
                  outlined                 
                  large
                  :disabled="sendingData"
                  @click="$router.go(-1)"
                >
                  กลับ
                </v-btn>                
              </v-card-actions>
          </v-card>
        </v-form>
    </div>
</template>
<script>
import { asyncGet, asyncPostAsJson } from '@/helpers/asyncAxios'
import { convertPageToText, convertPermissionToText } from '@/helpers/converter'
import { maxLengthValidator, required } from '@core/utils/validation'
export default {
  data() {
    return {
      isFormValid: false,
      sendingData: false,
      deviceList: [],
      abilities: [
        {
          subject: 'Dashboard',
          actions: ['display'],
        },
        {
          subject: 'Chat',
          actions: ['read', 'message'],
        },
        {
          subject: 'OnlineOrder',
          actions: ['read', 'update', 'delete'],
        },
        {
          subject: 'PosOrder',
          actions: ['read', 'update', 'delete'],
        },
        {
          subject: 'Product',
          actions: ['read', 'update', 'delete', 'cost', 'file'],
        },
        {
          subject: 'Customer',
          actions: ['read', 'update', 'delete'],
        },
        {
          subject: 'Report',
          actions: ['read', 'update', 'delete', 'file'],
        },
        {
          subject: 'Document',
          actions: ['read', 'update', 'delete', 'file'],
        },
        {
          subject: 'Employee',
          actions: ['read', 'update', 'delete'],
        },
        {
          subject: 'Setting',
          actions: ['read', 'update', 'delete'],
        },
        {
          header: 'สต็อก',
        },
        {
          subject: 'Stock',
          actions: ['read', 'update', 'delete', 'file'],
        },
        {
          subject: 'IVM',
          actions: ['read', 'update', 'delete'],
        },
        {
          subject: 'RETOG',
          actions: ['read', 'update', 'delete'],
        },
        {
          subject: 'Warehouse',
          actions: ['read', 'update', 'delete'],
        },
        {
          header: 'จัดซื้อ',
        },
        {
          subject: 'BuyOrder',
          actions: ['read', 'update', 'delete'],
        },
        {
          subject: 'ROG',
          actions: ['read', 'update', 'delete'],
        },
        {
          header: 'ตั้งค่า POS',
        },
        {
          subject: 'POSSetting',
          actions: ['read', 'update', 'delete'],
        },
        {
          subject: 'POSDevice',
          actions: ['read', 'update', 'delete'],
        },
      ],
      formData: {
        name: null,
        ability: null,
        devices: null,
      },
      validators: {
        required,
        maxLengthValidator,
      },
      converters: {
        convertPageToText,
        convertPermissionToText,
      },
    }
  },
  computed: {
    maxPermission() {
      const abilities = this.abilities.map(item => (!!item.actions ? item.actions.length : 0)).sort((a, b) => b - a)

      return abilities[0]
    },
  },
  async created() {
    const role_id = this.$route.params.role_id

    const newAbility = {}
    this.abilities.forEach(item => {
      newAbility[item.subject] = item.actions
    })

    this.formData.ability = newAbility

    if (role_id == 'create') {
      this.$store.commit('app/SET_APP_MODE', 'create')
      return
    } else if (this.$store.getters['auth/GET_ABILITY'].can('update', 'Employee'))
      this.$store.commit('app/SET_APP_MODE', 'edit')
    else this.$store.commit('app/SET_APP_MODE', 'read')

    this.$store.commit('app/SET_GLOBAL_LOADING', true)
    try {
      const response = await asyncGet('/employee/role/' + role_id)

      this.convertDataFromServerToForm(response)
    } catch (error) {
      this.$root.showCommonDialog('มีปัญหา', this.$errorParser(error))
    }
    this.$store.commit('app/SET_GLOBAL_LOADING', false)
  },
  methods: {
    async submitForm() {
      this.sendingData = true
      try {
        const role_id = this.$route.params.role_id

        if (role_id == 'create') await asyncPostAsJson('/employee/role', this.formData)
        else {
          await asyncPostAsJson('/employee/role/' + role_id, { ...this.formData, _method: 'PUT' })
        }

        this.$router.push({ name: 'role' })
      } catch (error) {
        console.log(error)
        this.$root.showCommonDialog('มีปัญหา', this.$errorParser(error))
      }

      this.sendingData = false
    },
    convertDataFromServerToForm({ id, name, ability, devices }) {
      this.formData.id = id
      this.formData.name = name
      this.formData.devices = devices

      const jsonAbility = JSON.parse(ability)

      const newAbility = this.formData.ability

      for (const [key, value] of Object.entries(newAbility)) {
        newAbility[key] = []
      }

      jsonAbility.forEach(element => {
        if (!newAbility[element.subject]) return

        newAbility[element.subject].push(element.action)
      })
    },
  },
  components: {},
}
</script>
<style scoped>
.ability-table > .ability-row {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.ability-table > .ability-row > .ability-name {
  min-width: 20%;
}

.ability-table > .ability-row > .ability-permission {
  min-width: 16%;
}

.ability-table > .ability-row > .ability-permission:last-of-type {
  width: 100%;
}
</style>